export const SET_ACCESS_TOKEN = (state, accessToken) => {
  state.accessToken = accessToken
}
